/**
 * Single Highcharts entry point for browser bundles.
 * Modules must register against the same Highcharts instance; bare
 * side-effect imports do not (Highcharts error #17: missingModuleFor=variablepie).
 * Adapted for Highcharts 11.x (factory modules); source PR 355312 used ESM paths
 * for Highcharts 13+ which are not available in this workspace.
 */
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import VariablePie from 'highcharts/modules/variable-pie';
import Drilldown from 'highcharts/modules/drilldown';
import Exporting from 'highcharts/modules/exporting';

type HighchartsModuleFactory = (highcharts: typeof Highcharts) => void;

function initHighchartsModule(mod: unknown): void {
  const factory = typeof mod === 'function'
    ? mod
    : (mod as { default?: unknown } | null)?.default;
  if (typeof factory === 'function') {
    (factory as HighchartsModuleFactory)(Highcharts);
  }
}

initHighchartsModule(HighchartsMore);
initHighchartsModule(VariablePie);
initHighchartsModule(Drilldown);
initHighchartsModule(Exporting);

export default Highcharts;
